<template>
  <div>
  <table class='max-70'>
    <thead>
      <tr>
        <th class="head-param">Calcul</th>
        <th class="result-width-min word-break" v-for='scenario in scenarios' :key='scenario.id_scenario'> {{ scenario.nom }}</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for='row in rows' :key='row.key'>
        <td v-tooltip="{ content : getTooltipMessage(row.key) }"><span>{{row.label}}</span></td>
        <td class="numeric-data" v-for='scenario in scenarios' :key='scenario.id_scenario + "-" + row.key'> {{ getValeur(scenario.id_scenario, row) | formatNumeric }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td class="secondaire" :colspan="scenarios.length + 1">
          <label>
            <input type="checkbox" v-model="avecAide" />
            Aide incluse
          </label>
        </td>
      </tr>
    </tfoot>
  </table>
  </div>
</template>

<script>

import { mapActions } from 'vuex'
import mixinTooltip from '@/mixins/tooltip'

export default {
  name: 'SimulationResultatIlot',
  mixins: [mixinTooltip],

  props: {
    selected: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      message: null,
      resultat: null,
      rows: [
        { key: 'marge_med', key_help: 'marge_med_aide', label: 'Marge nette médiane (€)', afficherAide: true, aideBySurface: true },
        { key: 'marge_med_ha', key_help: 'marge_med_ha_aide', label: 'Marge nette médiane (€ / ha)', afficherAide: true },
        { key: 'marge_moy', key_help: 'marge_moy_aide', label: 'Marge nette moyenne (€)', afficherAide: true, aideBySurface: true },
        { key: 'marge_moy_ha', key_help: 'marge_moy_ha_aide', label: 'Marge nette moyenne (€ / ha)', afficherAide: true },
        { key: 'cv', key_help: 'cv_aide', label: 'Coefficient de variation en %' },
        { key: 'freq_objectif', key_help: 'freq_objectif_aide', label: 'Fréquence d\'atteinte de l\'objectif (%)' },
        { key: 'conso_med', key_help: 'conso_med', label: 'Volume eau median consommé (m³)' },
        { key: 'conso_moy', key_help: 'conso_moy', label: 'Volume eau moyen consommé (m³)' }
        // 'conso_max': 'Volume eau max consommé (m³)',
        // 'conso_min': 'Volume eau min consommé (m³)'
      ],
      avecAide: true
    }
  },

  computed: {
    scenarios () {
      return this.$store.state.simulation.currentSimulation.scenarios
    },
    surface () {
      return this.$store.getters.selectedIlotSurface
    }
  },

  created () {
    this.loadResult()
  },

  methods: {
    ...mapActions(['loadByIlot', 'getExportForCSV']),

    loadResult () {
      this.loadByIlot()
        .then(data => (this.resultat = data))
    },
    getValeur (idScenario, info) {
      if (!this.resultat) {
        return ''
      }
      const record = this.resultat.find(data => data.id_scenario === idScenario)
      let key = (this.avecAide ? info.key_help : info.key) || info.key
      return (record ? record[key] : null) || ''
    }
  }

}
</script>

<style lang="scss">
  div.v-select.result-ilot {
    display: inline-block;
    width: 100%;
  }
</style>
